
import { FC, FormEvent } from "react";
import { Send } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface MessageInputProps {
  newMessage: string;
  setNewMessage: (message: string) => void;
  handleSendMessage: (e: FormEvent) => void;
  isLoading: boolean;
  disabled?: boolean;
}

const MessageInput: FC<MessageInputProps> = ({ 
  newMessage, 
  setNewMessage, 
  handleSendMessage, 
  isLoading,
  disabled = false
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="flex items-center px-4 py-3 gap-3">
      <form onSubmit={handleSendMessage} className="flex flex-1">
        <div className="flex w-full flex-1 items-stretch rounded-lg h-12">
          <input
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder={t('frank.ask_placeholder')}
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] focus:outline-0 focus:ring-0 border-none bg-[#f0f2f4] focus:border-none h-full placeholder:text-[#637588] px-4 rounded-r-none border-r-0 pr-2 text-base font-normal leading-normal"
            disabled={isLoading || disabled}
          />
          <div className="flex border-none bg-[#f0f2f4] items-center justify-center pr-4 rounded-r-lg border-l-0 !pr-2">
            <div className="flex items-center gap-4 justify-end">
              <button
                type="submit"
                disabled={!newMessage.trim() || isLoading || disabled}
                className="min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-8 px-4 bg-[#2F80ED] text-white text-sm font-medium leading-normal disabled:opacity-50 disabled:cursor-not-allowed flex"
              >
                <Send className="h-4 w-4 mr-1" />
                <span className="truncate">Send</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MessageInput;
